export const CREATE_CONTRACT_SUBJECT_MUTATION = `
  mutation CreateContractSubject($object: contract_subjects_insert_input!) {
    insert_contract_subjects_one(object: $object) {
      id
      name
      description
      status
      company_id
      is_project_based
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_CONTRACT_SUBJECT_MUTATION = `
  mutation UpdateContractSubject($id: Int!, $set: contract_subjects_set_input!) {
    update_contract_subjects_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      company_id
      is_project_based
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_CONTRACT_SUBJECT_MUTATION = `
  mutation DeleteContractSubject($id: Int!) {
    delete_contract_subjects_by_pk(id: $id) {
      id
    }
  }
`; 